<template>
    <zen-message-modal :isOpen="isOpen" title="Effective permissions">
        <p class="text-sm text-taupe-500 mb-4">
            {{ target?.name }}
        </p>
        <div v-if="loading" class="text-sm text-taupe-500">Loading…</div>
        <div v-else-if="permissions" class="space-y-4">
            <div>
                <p class="text-sm font-medium text-taupe-800 mb-1">Scopes</p>
                <div class="flex flex-wrap gap-1">
                    <span
                        v-for="scope in permissions.scopes"
                        :key="scope"
                        class="inline-flex items-center rounded-full bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-700 ring-1 ring-inset ring-sky-700/10"
                    >
                        {{ scope }}
                    </span>
                </div>
            </div>
            <div>
                <p class="text-sm font-medium text-taupe-800 mb-1">
                    Resource access
                </p>
                <p
                    v-if="permissions.unrestricted"
                    class="text-sm text-taupe-500"
                >
                    Unrestricted — all projects and environments.
                </p>
                <ul v-else class="space-y-1 text-sm text-taupe-700 font-mono">
                    <li
                        v-for="(
                            constraint, idx
                        ) in permissions.resource_constraints"
                        :key="idx"
                    >
                        <span
                            class="inline-block rounded bg-taupe-100 px-1.5 py-0.5 text-xs"
                            >{{ constraint.resource_type }}</span
                        >
                        {{ constraint.resource_ulid }}
                    </li>
                </ul>
            </div>
        </div>
        <template v-slot:buttons>
            <zen-button variant="primary" @click="$emit('close')">
                Close
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'EffectiveApiTokenPermissionsModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        target: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        permissions: {
            type: Object,
            default: null,
        },
    },
    emits: ['close'],
}
</script>
